import {
  Users,
  BellRing,
  FileText,
  Lock,
  BookOpenCheck,
  Clock,
} from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

export const Features = () => {
  const { t } = useLang();

  const items = [
    {
      icon: BookOpenCheck,
      title: t.features.f1Title,
      desc: t.features.f1Desc,
      span: "md:col-span-7",
      image:
        "https://images.unsplash.com/photo-1554224154-26032ffc0d07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxhY2NvdW50aW5nJTIwbGVkZ2VyJTIwYW5kJTIwY2FsY3VsYXRvcnxlbnwwfHx8fDE3ODA4NTI5NjZ8MA&ixlib=rb-4.1.0&q=85&w=800",
    },
    { icon: BellRing, title: t.features.f2Title, desc: t.features.f2Desc, span: "md:col-span-5" },
    { icon: FileText, title: t.features.f3Title, desc: t.features.f3Desc, span: "md:col-span-5" },
    {
      icon: Users,
      title: t.features.f4Title,
      desc: t.features.f4Desc,
      span: "md:col-span-7",
      image:
        "https://images.pexels.com/photos/8297220/pexels-photo-8297220.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=600",
    },
    { icon: Lock, title: t.features.f5Title, desc: t.features.f5Desc, span: "md:col-span-6" },
    { icon: Clock, title: t.features.f6Title, desc: t.features.f6Desc, span: "md:col-span-6" },
  ];

  return (
    <section
      id="features"
      data-testid="features-section"
      className="py-20 lg:py-28 bg-stone-100/60 border-y border-stone-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="font-mono-label text-stone-600">{t.features.eyebrow}</span>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-900 leading-tight">
            {t.features.title}
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-6">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={i}
                data-testid={`feature-card-${i + 1}`}
                className={`${it.span} bg-white border border-stone-200 rounded-2xl p-8 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 ${
                  it.image ? "overflow-hidden" : ""
                }`}
              >
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-lg bg-green-900/10 text-green-900 grid place-items-center shrink-0">
                    <Icon size={20} />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-display text-xl text-stone-900">
                      {it.title}
                    </h3>
                    <p className="mt-2 text-stone-600 leading-relaxed">
                      {it.desc}
                    </p>
                  </div>
                </div>
                {it.image && (
                  <img
                    src={it.image}
                    alt={it.title}
                    className="mt-6 w-full h-44 object-cover rounded-xl border border-stone-200"
                    width="600"
                    height="176"
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
